import mobx, { observable, action, computed } from 'mobx';
import api from '../../api';
// import accountStore from '../accountStore';
// import appStore from '../appStore';

export default class Cardsall {

	store = null;
	@observable data = null;
	@observable pageData = null;
	@observable isLoading = 1;
	@observable page = '';
	@observable id = 0;
	@observable pages = [];

	constructor(store) {
		this.store = store;
	}

	@action init(params) {
		this.id = params.cardId || 0;
		this.page = params.page || '';
		this.store.isLoading = 0;
		this.getData();
	}

	@action dispose(){
		this.page = '';
	}

	@action selectPage(v) {
		this.getPageData(v);
	}

	@action getData(){
		api.toto.getCardsAll({id: this.id, page: this.page}).then(
			action( data => { 
				if (data.code == "OK") {
					this.data = data.result;
					this.pages = data.result.pages.split('');
				}
			}))
      .catch(action(err => {
        this.store.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.store.isLoading = 1 }));
	}

	@action getPageData(v){
		this.isLoading = 1;
		api.toto.getCardsPage({id: this.id, page: v}).then(
			action( data => { 
				if (data.code == "OK") {
					this.pageData = data.result;
					this.page = v;
				} else {
					this.pageData = '';
				}
			}))
      .catch(action(err => {
        this.store.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.isLoading = 0 }));
	}
}


// WEBPACK FOOTER //
// ./src/stores/totoStore/cardsall.js